// Typelizer digest ac5036a6ae16a3443737d097fb4ddb8f
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /accountant/deadlines */
  index: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/accountant/deadlines', {}, options),
    method: 'get',
  }),
}
